import React from 'react';
import Icon from '../../../baseComponents/gui/icon/Icon';
import { getStoreLogo } from '../../../../utils/getStoreLogo';
import useErudaHack from '../../../../utils/eruda/useErudaHack';
import classNames from 'classnames';
import { useRequests } from '../../../../redux/reducer/requests';

const StartHeader = React.forwardRef(function (_, ref) {
  const logo = getStoreLogo();

  const erudaElementRef = useErudaHack();

  const {
    authData: { isWeb },
  } = useRequests();

  return (
    <header
      className={classNames('start__header', { start__header_app: !isWeb })}
      ref={erudaElementRef}
      onClick={(e) => e.stopPropagation()}
    >
      <Icon name={logo.icon} />
    </header>
  );
});
export default StartHeader;
